const TOKEN_KEYS = ["dsf_token", "token", "accessToken"];

export const getAuthToken = () => {
  for (const key of TOKEN_KEYS) {
    const sessionToken = sessionStorage.getItem(key);
    if (sessionToken) return sessionToken;
  }

  for (const key of TOKEN_KEYS) {
    const localToken = localStorage.getItem(key);
    if (localToken) return localToken;
  }

  return "";
};

export const isAuthenticated = () =>
  sessionStorage.getItem("dsf_auth") === "authenticated" && Boolean(getAuthToken());

export const clearAuth = () => {
  ["dsf_auth", "dsf_token", "token", "accessToken", "dsf_user"].forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};

export const getLoginApiUrl = () =>
  (process.env.REACT_APP_LOGIN_API_URL || "https://dsf-api.classicprogrammers.com/api/v1").replace(
    /\/+$/,
    ""
  );

export const getAdminApiUrl = () =>
  (
    process.env.REACT_APP_API_BASE_URL || "https://dsf-api.classicprogrammers.com/api/v1/admin"
  ).replace(/\/+$/, "");
